module.exports = __webpack_public_path__ + "static/media/Logo__Facebook.a86e5997.svg";